module.exports = __webpack_public_path__ + "img/cwc-qrcode.a7c314fc.png";